import { render } from "./InputUpload.vue?vue&type=template&id=092f88d8"
import script from "./InputUpload.vue?vue&type=script&lang=js"
export * from "./InputUpload.vue?vue&type=script&lang=js"
script.render = render

export default script